import styled from '@emotion/styled';

export const ConferenceContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;
export const ContentTabList = styled.div`
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.size6xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	text-align: left;
`;

export const ConferenceSearchBox = styled.div`
	display: flex;
	gap: 0.4rem;
	justify-content: flex-end;
	width: 100%;
	height: 4.4rem;
`;

export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ConferenceGalleryBox = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 2rem;
	width: 100%;
	@media screen and (max-width: 1370px) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media screen and (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
export const GalleryItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-width: 0; /* ✅ 부모보다 커지지 않도록 강제 */
	cursor: pointer;
	.img_box {
		width: 100%;
		height: 22rem;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;

	/* max-width: 32.2rem;
	width: 100%; */

	.title {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.date {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: 100%;
		letter-spacing: -0.6px;
		color: #868e96;
	}
`;
export const ConferenceGalleryImgBox = styled.div`
	height: 22rem;
`;
export const EmptyData = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;

// Tabs
export const PortfolioTabs = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
  @media screen and (max-width: 600px) {
    gap: 8px;
    flex-wrap: wrap;
  }
`;

export const PortfolioTabButton = styled.button<{ isActive?: boolean }>`
  display: flex;
  height: 48px;
  min-width: 220px;
  padding: 0 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 200px;
  background: ${({ isActive }) => (isActive ? '#004ED8' : '#ECECEC')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#222')};
  border: none;
  cursor: pointer;
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-weight: 600;
  @media screen and (max-width: 600px) {
    height: 40px;
    min-width: auto;
    padding: 0 16px;
    font-size: 14px;
  }
`;

// Card List Wrapper
export const PortfolioCardListWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
`;

// Card
export const PortfolioCard = styled.article`
  width: 1350px;
  height: 560px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--color-white, #fff);
  box-shadow: 0 16px 40px 0 rgba(154, 154, 154, 0.2);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px; /* 내용과 이미지 사이 간격 */
  padding: 80px; /* 카드와 내부 콘텐츠 여백 */

  @media screen and (max-width: 1370px) {
    width: 100%;
  }

  @media screen and (max-width: 900px) {
    height: auto;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
  }
  @media screen and (max-width: 600px) {
    gap: 16px;
    padding: 16px;
  }
`;

export const PortfolioCardLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 1 auto;

  @media screen and (max-width: 900px) {
    align-items: center;
    text-align: center;
  }
`;

export const PortfolioIconSlot = styled.div<{ bgImg?: string }>`
  width: 112px;
  height: 24px;
  aspect-ratio: 14 / 3;
  background: ${({ bgImg }) => (bgImg ? `url(${bgImg}) center / contain no-repeat` : 'transparent')};
  @media screen and (max-width: 600px) {
    width: 84px;
    height: 18px;
  }
`;

export const PortfolioTitle = styled.h3`
  align-self: stretch;
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.6px;

  @media screen and (max-width: 900px) {
    font-size: 28px;
  }
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
`;

export const PortfolioPeriod = styled.p`
  align-self: stretch;
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 180% */
  letter-spacing: -0.8px;
  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const MorePhotoButton = styled.button`
  width: 160px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 100px;
  background: #90B8FF;
  border: none;
  color: #fff;
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    width: 140px;
    height: 40px;
    font-size: 14px;
  }
`;

export const PortfolioDetailsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PortfolioDetailsItem = styled.li`
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: -0.8px;
  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const PortfolioCardRight = styled.div`
  flex: 0 0 auto;
`;

export const PortfolioImage = styled.div<{ bgImg: string }>`
  width: 668px;
  height: 401px;
  flex-shrink: 0;
  aspect-ratio: 663 / 398;
  border-radius: 16px;
  background: url(${({ bgImg }) => bgImg}) lightgray 0px -10.214px / 100% 107.089% no-repeat;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 900px) {
    width: 100%;
    height: auto;
  }
`;

// Modal for photo gallery
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  width: auto;
  max-height: 90vh;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h4`
  margin: 0;
  font-family: 'Pretendard Variable';
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

export const ModalClose = styled.button`
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
`;

export const ModalBody = styled.div`
  width: 100%;
`;

export const ModalSwiperWrap = styled.div`
  position: relative;
  width: auto;
  max-width: 92vw;
  margin: 0 auto;
  z-index: 1005;
`;

export const ModalStage = styled.div`
  position: relative;
  width: 860px;
  height: 480px;
  margin: 0 auto;
  max-width: 92vw;
  @media screen and (max-width: 900px) {
    width: 100%;
    max-width: 92vw;
    height: auto;
  }
`;

export const ModalImgEl = styled.img`
  width: 860px;
  height: 480px;
  display: block;
  object-fit: contain;
  @media screen and (max-width: 900px) {
    width: 100%;
    height: auto;
    max-height: 60vh;
  }
`;

export const ModalNavButton = styled.button<{ side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ side }) => (side === 'left' ? 'left: -98px;' : 'right: -98px;')}
  width: 70px;
  height: 70px;
  aspect-ratio: 1 / 1;
  border: none;
  background: transparent;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1010;
  pointer-events: auto;
  img { width: 70px; height: 70px; display: block; }
  @media screen and (max-width: 900px) {
    ${({ side }) => (side === 'left' ? 'left: 8px;' : 'right: 8px;')}
  }
  @media screen and (max-width: 600px) {
    width: 48px;
    height: 48px;
    img { width: 48px; height: 48px; }
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: -50px; /* move ~30px higher from previous 8px */
  left: 50%;
  transform: translateX(-50%);
  width: 44px;
  height: 44px;
  aspect-ratio: 1 / 1;
  border: 2px solid rgba(255, 255, 255, 0.9);
  background: rgba(255,255,255,0.9);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1011;
  pointer-events: auto;
  box-shadow: 0 6px 16px rgba(0,0,0,0.35);
  transition: transform 0.15s ease, background 0.2s ease, box-shadow 0.2s ease;
  img { width: 26px; height: 26px; display: block; filter: invert(1); }
  &:hover { background: rgba(0,0,0,0.7); transform: translateX(-50%) scale(1.05); box-shadow: 0 8px 20px rgba(0,0,0,0.4); }
  &:active { transform: translateX(-50%) scale(0.98); }
  @media screen and (max-width: 900px) {
    top: -50px;
  }
  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    img { width: 22px; height: 22px; }
  }
`;

// Removed ModalPagination styles as pagination is no longer used

// Team Page
// 조직구성 하위 리스트 컨테이너
export const TeamListSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4.8rem; /* 48px */
`;

// 카드들을 담는 래퍼: 가로로 최대 3개, 초과 시 줄바꿈
export const TeamCardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4rem; /* 카드 간격 40px */
  width: 100%;
  @media screen and (max-width: 900px) {
    gap: 2rem;
  }
`;

// 단일 카드
export const TeamCard = styled.article`
  display: flex;
  width: 423.333px;
  min-height: 436px;
  padding: 48px;
  align-items: flex-start;
  gap: 0; /* 상단/본문 간격은 내부 컨테이너에서 제어 */
  flex: 0 0 423.333px; /* 3열 고정 배치 */
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--color-white, #fff);
  box-shadow: 0 16px 40px 0 rgba(154, 154, 154, 0.2);

  @media screen and (max-width: 900px) {
    width: 100%;
    flex: 1 0 100%;
    padding: 24px;
  }
`;

// 카드 내 좌측(혹은 상단) 정보 블록: 직급/이름
// 카드 내부 전체 레이아웃: 상단(직급/이름)과 하단(주요 경력) 사이 간격 50px
export const TeamCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  height: 340px;
  flex: 1 0 0;
  align-self: stretch;
`;

// 상단 헤더: 직급(좌) / 이름(우)
export const TeamCardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

// 직급 블록
export const TeamCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const TeamCardPosition = styled.span<{ isCeo?: boolean }>`
  color: ${({ isCeo }) => (isCeo ? '#004ED8' : '#222')};
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.72px;
`;

export const TeamCardName = styled.h3`
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.12px;
  @media screen and (max-width: 900px) {
    font-size: 24px;
  }
`;

// 직급 배지(대표이사: 하늘색, 기타: 회색)
export const PositionBadge = styled.div<{ isCeo?: boolean }>`
  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 9999px;
  background: ${({ isCeo }) => (isCeo ? '#EBF1FF' : '#ECECEC')};
`;

// 카드 본문(주요 경력 영역 컨테이너)
export const TeamCardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

export const ExperienceTitle = styled.h4`
  color: #222;
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.72px;
`;

export const ExperienceList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ExperienceItem = styled.li`
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 133.333% */
  letter-spacing: -0.72px;
`;

export const ExperienceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const BulletDot = styled.span`
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #004ED8;
  flex: 0 0 auto;
`;

// 상단과 하단 사이 가변 간격: 최소 50px 보장, 남는 공간을 차지하여 본문을 하단 정렬
export const TeamCardSpacer = styled.div`
  flex: 1 0 50px;
  width: 100%;
`;
